<template>
  <span class="tooltip" :style="{ left: xCoords + 'px', top: yCoords + 'px' }">
    {{ $t("result.lees_meer") }}
  </span>
</template>

<script>
// export default {
//   data() {
//     return {
//       xCoords: null,
//       yCoords: null,
//     };
//   },
//   mounted() {
//     document.addEventListener("mousemove", this.followMouse);
//   },
//   beforeDestroy() {
//     document.removeEventListener("mousemove", this.followMouse);
//   },
//   methods: {
//     followMouse(e) {
//       this.xCoords = e.pageX;
//       this.yCoords = e.pageY;
//     },
//   },
// };

import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  name: "YourComponentName",
  setup() {
    // Define reactive state for x and y coordinates
    const xCoords = ref(null);
    const yCoords = ref(null);

    // Define the followMouse function to update x and y coordinates
    const followMouse = (e) => {
      xCoords.value = e.pageX;
      yCoords.value = e.pageY;
    };

    // Add an event listener for mouse movements when the component is mounted
    onMounted(() => {
      document.addEventListener("mousemove", followMouse);
    });

    // Remove the event listener when the component is about to be destroyed
    onBeforeUnmount(() => {
      document.removeEventListener("mousemove", followMouse);
    });

    // Return reactive variables and methods so they can be used in the template
    return {
      xCoords,
      yCoords,
      followMouse,
    };
  },
};
</script>

<style lang="sass" scoped>
.tooltip
  position: absolute
  display: flex
  background: $grey
  z-index: 10000
  width: 89px
  height: 30px
  align-items: center
  justify-content: center
  box-shadow: 0 2px 10px 0 $black
  border-radius: 15px
  font-size: 13px
  line-height: 14px
</style>
